import { useQuery, useQueryClient } from "@tanstack/react-query";
import { EndpointsService } from "../services/endpoints/endpoints.service";
import { getLocalStorageUser } from "../services/session/auth.service";

export const useAppointmentsUpcoming = () => {
	const queryClient = useQueryClient();
	const queryKey = ["appointments-upcoming"];

	const query = useQuery(queryKey, async () => {
		const response = await EndpointsService.appointments.getAppointmentsByParticipant({
			config: {
				params: {
					minDate: null,
					maxDate: null,
					kannactId: getLocalStorageUser().kannactId,
					email:
						getLocalStorageUser().emails?.filter((x) => x.isPrimary)[0]
							?.emailAddress || undefined,
				},
			},
		});
		return response;
	});

	return {
		...query,
		invalidate: () => queryClient.invalidateQueries(queryKey),
	};
};
